module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'long': _vm.long
    },
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    },
    attrs: {
      "id": "chart-container"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.styleText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('EventReport')) + " (" + _vm._s(_vm.$t('By Date')) + ")")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('period')) + ":" + _vm._s(_vm.days))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1"
  }, [_c('tr', [_c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('uername')) + ": " + _vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('fullName')) + ": " + _vm._s(_vm.statics.name))]), _vm._v(" "), _c('td', {
    staticClass: "td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ": " + _vm._s(_vm.statics.medical_history))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('HbA1c')) + ": " + _vm._s(_vm.hb1c))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "29px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Event Summary')))]), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p >= 1) ? _c('div', [_c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "events-table",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "td5",
      attrs: {
        "width": "52px"
      }
    }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('td', {
      staticClass: " spe1 td5"
    }), _vm._v(" "), _vm._l((_vm.hours), function(i) {
      return _c('td', {
        staticClass: "td2"
      }, [_vm._v(_vm._s(i))])
    }), _c('td', {
      staticClass: "spe2 td5"
    }, [_vm._v("Avg/#")])], 2)]), _vm._v(" "), _vm._l((_vm.whichDate.slice(base, base + _vm.perPage[p])), function(day, index) {
      return _c('table', {
        staticClass: "events-table",
        attrs: {
          "id": base + index
        }
      }, [_c('tr', [_c('td', {
        staticClass: "td1 td4",
        attrs: {
          "rowspan": "4",
          "width": "52px"
        }
      }, [_vm._v(_vm._s(day))]), _vm._v(" "), _c('td', {
        staticClass: "td1 spe1"
      }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3"
      }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td')
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 spe2"
      })], 2), _vm._v(" "), _c('tr', [_c('td', {
        staticClass: "td3 td4"
      }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _vm._v(" "), _vm._l((24), function(i) {
        return _c('td', {
          staticClass: "td4"
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "td1 td4 spe2"
      })], 2)])
    })], 2)
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statics"
  }, [_c('p', {
    staticClass: "custom"
  }, [_vm._v(_vm._s(_vm.$t('static')))]), _vm._v(" "), _c('table', {
    staticClass: "statics-table"
  }, [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('type')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Avg')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('SD')))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('max')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('min')))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('#')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('BG1')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bgstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bgstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('carbs')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.carbstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.carbstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.$t('Injection')))]), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_vm._v(_vm._s(_vm.bolstat.day.min))]), _c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.bolstat.day.num))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.$t('exercise')))]), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.avg))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.sd))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.max))]), _vm._v(" "), _c('td', {
    staticClass: "td3"
  }, [_vm._v(_vm._s(_vm.exerstat.day.min))]), _c('td', [_vm._v(_vm._s(_vm.exerstat.day.num))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a44b2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/quickPrint6.vue
// module id = 1451
// module chunks = 7